import React, { useEffect, useState } from "react"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import {
  getProviderIps,
  getProviderIpsStock,
  getProviderItemCategories,
  getProviderItems,
  getProviderProjects,
  getProviderStock,
} from "store/provider-dashboard/provider-dashboard-action"
import ProviderDashboardComponent from "components/ProviderDashboard/ProviderDashboardComponent"
import ProviderInventoryListComponent from "components/ProviderReports/Inventory"
import { exportProviderInventoryReport } from "store/provider-reports/p-report-action"

const ProviderInventoryList = props => {
  //meta title
  document.title = "Dashboard"

  const [params, setParams] = useState({})
  const [fitlers, setFilters] = useState(null)
  const providerStock = useSelector(
    state => state.providerDashboard.providerStock
  )

  const dispatch = useDispatch()

  const onSubmit = values => {
    setParams(values)
    dispatch(getProviderStock(values))
  }

  const onProviderSearchHandler = values => {
    setFilters(values)
  }

  const onExport = () => {
    dispatch(exportProviderInventoryReport(params))
  }

  const onCategoryChange = category => {
    dispatch(getProviderItems({ ids: category }))
  }

  useEffect(() => {
    dispatch(getProviderStock())
    dispatch(getProviderIps())
    dispatch(getProviderItemCategories())
    dispatch(getProviderProjects())
  }, [])

  return (
    <React.Fragment>
      <Breadcrumbs title={"Provider"} breadcrumbItem={"Inventory"} />
      <ProviderInventoryListComponent
        provStock={providerStock?.data?.data?.providerReports}
        provData={providerStock?.data?.data}
        onSubmit={onSubmit}
        onCategoryChange={onCategoryChange}
        onExport={onExport}
        onProviderSearchHandler={onProviderSearchHandler}
      />
    </React.Fragment>
  )
}

export default ProviderInventoryList
